import React, { useContext, useMemo, useState } from "react";
import { clinicInfoContext } from '.'
import { ClinicInfoCard } from "src/components/ClinicInfoCard";
import { Card, Modal, Panel } from "@myhealth-raccoon/components";
import { useBreakpoints } from "src/hooks/useBreakpoints";
import { cancellationPolicyContext } from "../cancellationPolicy";
import { clinicName } from "src/utils/name";

export function ClinicInfoProvider({ children }: React.PropsWithChildren) {
    const [isOpen, setIsOpen] = useState(false);
    const [title, setTitle] = useState("");
    const breakpoint = useBreakpoints();

    const value = useMemo(() => ({
        setOpen: setIsOpen,
        isOpen
    }),
        [isOpen]);

    const { setOpen: setCancellationPolicyOpen } = useContext(cancellationPolicyContext);

    if (["lg", "xl", "2xl"].indexOf(breakpoint) >= 0) {
        return <clinicInfoContext.Provider value={value}>
            {children}
            <Modal
                open={isOpen}
                onClose={() => setIsOpen(false)}
                size="sm"
                unstyled
                hideX
            >
                <Card.Shell>
                    <ClinicInfoCard
                    />
                </Card.Shell>
            </Modal>
        </clinicInfoContext.Provider>
    } else {
        return <clinicInfoContext.Provider value={value}>
            {children}
            <Panel
                open={isOpen}
                setOpen={setIsOpen}
                attachedTo="bottom"
                title={<div className="px-2 py-3 text-lg text-gray-900 font-semibold">{title}</div>}
            >
                <ClinicInfoCard
                    onLoad={(clinic) => setTitle(clinicName(clinic)!)}
                    hideMap
                    hideTitle
                    onClickCancellationPolicy={() => {
                        setIsOpen(false);
                        setCancellationPolicyOpen(true);
                    }}
                />
            </Panel>
        </clinicInfoContext.Provider>
    }


}